/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';

const CompanyName = props => {
  const { name, title, parentClass = '', clsName = '' } = props;

  return (
    <div className={`contact-name ${parentClass}`}>
      <div className={`name ${clsName}`}>{name}</div>
      {/* <div className="title">{title}</div> */}
    </div>
  );
};

export { CompanyName };
export default CompanyName;
